var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278,
    height: 76,
    viewBox: "0 0 278 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8846",
    "data-name": "Group 8846",
    transform: "translate(-1427 -593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1720",
    "data-name": "Rectangle 1720",
    transform: "translate(1427 593)",
    fill: "#fff",
    stroke: "#002147",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 76,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 277,
    height: 75,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M0,41.625H7.065V23.21c0-3.632,2.383-6.271,5.788-6.271,3.291,0,5.334,2.071,5.334,5.419V41.624h6.867V23.039c0-3.6,2.327-6.1,5.732-6.1,3.462,0,5.391,2.1,5.391,5.788v18.9h7.065V21c0-6.015-3.887-10.016-9.818-10.016a9.7,9.7,0,0,0-9.364,6.044h-.17c-1.107-3.859-4.143-6.044-8.4-6.044a8.843,8.843,0,0,0-8.569,5.788H6.781V11.548H0V41.625Zm58.707-4.852c-3.064,0-5.107-1.561-5.107-4.029,0-2.383,1.958-3.916,5.363-4.143l6.952-.426v2.3c0,3.632-3.206,6.3-7.207,6.3Zm-2.128,5.334a10.633,10.633,0,0,0,9.364-5.278h.142v4.8h6.81V20.912c0-6.044-4.852-9.988-12.314-9.988-7.661,0-12.456,4.029-12.768,9.647h6.554c.454-2.5,2.582-4.114,5.93-4.114,3.49,0,5.618,1.816,5.618,4.965v2.156l-7.945.454c-7.32.454-11.435,3.66-11.435,8.995,0,5.419,4.228,9.08,10.044,9.08Zm47.329-19.834c-.482-6.327-5.391-11.35-13.336-11.35-8.739,0-14.414,6.044-14.414,15.662,0,9.761,5.675,15.634,14.471,15.634,7.548,0,12.74-4.426,13.307-11.151H97.269a6.238,6.238,0,0,1-6.554,5.448c-4.483,0-7.377-3.632-7.377-9.931,0-6.186,2.866-9.931,7.32-9.931a6.367,6.367,0,0,1,6.583,5.618h6.668ZM125.73,0c-11.945,0-19.436,8.143-19.436,21.167s7.49,21.139,19.436,21.139c11.917,0,19.408-8.115,19.408-21.139S137.648,0,125.73,0Zm0,6.242c7.292,0,11.945,5.788,11.945,14.925,0,9.108-4.653,14.9-11.945,14.9-7.32,0-11.945-5.788-11.945-14.9C113.785,12.031,118.41,6.242,125.73,6.242Zm22.388,23.863c.312,7.548,6.5,12.2,15.918,12.2,9.9,0,16.145-4.88,16.145-12.655,0-6.1-3.518-9.534-11.832-11.435l-4.71-1.078c-5.022-1.192-7.094-2.781-7.094-5.5,0-3.4,3.121-5.675,7.746-5.675,4.682,0,7.888,2.3,8.228,6.129h6.98C179.33,4.881,173.372,0,164.349,0c-8.91,0-15.237,4.909-15.237,12.173,0,5.845,3.575,9.477,11.122,11.208l5.306,1.248c5.164,1.22,7.264,2.923,7.264,5.873,0,3.4-3.433,5.845-8.37,5.845-4.994,0-8.767-2.469-9.221-6.242h-7.094Z",
    transform: "translate(1476 610)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOs);
export default __webpack_public_path__ + "static/media/mac-os.9f5eb890604c778cc9fa6897b5a61186.svg";
export { ForwardRef as ReactComponent };